document.addEventListener('click', function (event) {
  var button = event.target.closest('.amazon-buy-button');
  if (!button) return;

  var payload = {
    asin: button.getAttribute('data-asin'),
    product_id: button.getAttribute('data-product-id'),
    product_title: button.getAttribute('data-product-title'),
  };

  if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
    window.Shopify.analytics.publish('amazon_click', payload);
  }
});